import { useEffect, useState } from "react";

import { Button } from "atoms/button/Button";
import { TextArea } from "atoms/TextArea";

import { QuizStepProps } from "../useQuestionnaire";

import YesNo from "./components/YesNo";

export const FurtherNotes = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);

  const handleChange = (value: string) => {
    props.handleStepData("FurtherNotesQuestion", value);
    props.handleStepData("FurtherNotes", "");
    if (value === "No") {
      setLastUpdate({ key: "FurtherNotesQuestion", value });
    }
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [lastUpdate]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="flex h-full flex-col gap-4">
      <p className="pb-8 font-serif text-h3">
        Do you have any further information which you would like the doctor to
        know? Please do not include urgent or emergent medical information here,
        as this is not reviewed immediately.
      </p>
      <div className="flex gap-3">
        <YesNo
          value={props.data.FurtherNotesQuestion}
          onChange={(value) => handleChange(value)}
        />
      </div>
      <div hidden={props.data.FurtherNotesQuestion !== "Yes"}>
        <TextArea
          label="Further Notes"
          value={props.data.FurtherNotes as string}
          onChange={(value) => props.handleStepData("FurtherNotes", value)}
          invalid={!!props.errors?.FurtherNotes}
        />
        <div hidden={!props.errors?.FurtherNotes}>
          <p className="mt-2 text-sm text-red">
            Please enter your further notes.
          </p>
        </div>
      </div>
      <div
        hidden={props.data.FurtherNotesQuestion !== "Yes"}
        className="mt-auto"
      >
        <Button fullWidth onClick={props.next}>
          Next Question
        </Button>
      </div>
    </div>
  );
};
